import { render, staticRenderFns } from "./Prelude.vue?vue&type=template&id=850a9bec&scoped=true&"
import script from "./Prelude.vue?vue&type=script&lang=js&"
export * from "./Prelude.vue?vue&type=script&lang=js&"
import style0 from "./Prelude.vue?vue&type=style&index=0&id=850a9bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850a9bec",
  null
  
)

export default component.exports